import styled from 'styled-components';

export const LocationName = styled.h2`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
`;